import { Video, ScanFace, FileText, Target } from "lucide-react";
import { RevealOnScroll } from "./RevealText";
import { howItWorksIcons, howItWorksStepNums } from "../data/staticData";
import { useLanguage } from "../i18n/LanguageContext";

const icons = { Video, ScanFace, FileText, Target };
const ids = ["record", "analyze", "report", "decide"];

export function HowItWorks() {
  const { t } = useLanguage();
  return (
    <section id="how-it-works" className="relative py-24 lg:py-32 bg-[#0A0A0C]" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <RevealOnScroll className="max-w-2xl mb-20">
          <span className="font-mono-data text-xs text-[#00F0FF]">/ {t.nav.howItWorks.toUpperCase()}</span>
          <h2 className="mt-4 font-display font-bold text-4xl sm:text-5xl text-white tracking-tighter">
            {t.howItWorks.title}
          </h2>
          <p className="mt-4 text-zinc-400 text-base sm:text-lg">{t.howItWorks.subtitle}</p>
        </RevealOnScroll>

        <div className="space-y-2">
          {t.howItWorks.steps.map((s, i) => {
            const Icon = icons[howItWorksIcons[i]];
            return (
              <RevealOnScroll key={ids[i]} delay={i * 0.1}>
                <div
                  className="group relative flex flex-col sm:flex-row items-start sm:items-center gap-6 py-10 border-b border-white/10"
                  data-testid={`how-it-works-step-${ids[i]}`}
                >
                  <span className="font-display font-black text-6xl sm:text-8xl text-white/[0.05] leading-none tabular-nums group-hover:text-[#00F0FF]/10 transition-colors duration-300">
                    {howItWorksStepNums[i]}
                  </span>
                  <div className="flex-1">
                    <div className="flex items-center gap-3">
                      <Icon className="w-5 h-5 text-[#00F0FF]" strokeWidth={1.5} />
                      <h3 className="font-display font-semibold text-xl sm:text-2xl text-white">{s.title}</h3>
                    </div>
                    <p className="mt-2 text-zinc-500 text-sm sm:text-base max-w-xl leading-relaxed">
                      {s.description}
                    </p>
                  </div>
                </div>
              </RevealOnScroll>
            );
          })}
        </div>
      </div>
    </section>
  );
}
